/**
 * @generated SignedSource<<16e19713d9f0bff2841d815c12afe04a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TableBody_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp_rank">;
  readonly " $fragmentType": "TableBody_rankField";
};
export type TableBody_rankField$key = {
  readonly " $data"?: TableBody_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"TableBody_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "TableBody_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "FragmentSpread",
      "name": "RenderChildRowsComp_rank"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "3b686d9f0dadcc2230fcc1b560e63dd1";

export default node;
